/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Search_PlaceholderInputs */

const cs_gdpr_search_placeholder = /** @type {(inputs: Gdpr_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jméno, e-mail nebo telefon`)
};

const en_gdpr_search_placeholder = /** @type {(inputs: Gdpr_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name, e-mail or phone`)
};

/**
* | output |
* | --- |
* | "Name, e-mail or phone" |
*
* @param {Gdpr_Search_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_search_placeholder = /** @type {((inputs?: Gdpr_Search_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Search_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_search_placeholder(inputs)
	return cs_gdpr_search_placeholder(inputs)
});